<mat-sidenav-container class="imei-info-sidenav-container" style="height: 100%;">
  <mat-sidenav #imeisidenav position="end" mode="over" [(opened)]="opened" (opened)="events.push('open!')"
              (closed)="events.push('close!')">
              <pgh-imei-info (closeEvent)="closeSideNav()" [isDiagnosticInviteFlow]="true" [imeiInfoDeviceType]="imeiInfoDeviceType"></pgh-imei-info>
  </mat-sidenav>
  
  <mat-sidenav-content>

<div style="height: 100%;">
  <ng-container>
   
    <div class="back container pt-4" *ngIf="isBackVisible">
      <button class="link" (click)="gotoBack()" style="padding-left:0px;"><mat-icon
          style="padding-top:6px;">keyboard_arrow_left</mat-icon>
          <adp-label labelKey="Global_Button_Back"></adp-label></button>
    </div>

  <pgh-landing-page *ngIf="state === states.LandingPage" (nextEvent)="loadDevice()"></pgh-landing-page>
  <div [ngClass]="state != states.LandingPage?'phone-registration-page':''">
    <pgh-next-steps *ngIf="state === states.NextSteps" (nextEvent)="changeState(states.ConfirmNumber)"
        (backEvent)="changeState(states.LandingPage)" [nextStepsInfoDeviceTypeTemplate]="nextStepsInfoDeviceTypeTemplate"></pgh-next-steps>


  <pgh-confirm-number *ngIf="state === states.ConfirmNumber" [device]="device" (nextEvent)="goToImeiLookup({'data': $event,'state' : states.ImeiInfo})"></pgh-confirm-number>
  <pgh-imei-lookup *ngIf="state === states.ImeiInfo" [isOnboardingFlow]="true" [onboardingFlowDevice]="device"
    [imeiLookupDeviceTypeTemplate]="imeiLookupDeviceTypeTemplate"
    (viewIMEIInfo)="sidenav.toggle()"
    (nextEvent)="handleImeiLookupCompleted($event)">
  </pgh-imei-lookup>

  <pgh-cellular-device-info-form class="step-item" *ngIf="state === states.ProvideAdditionalInfo"
    preHeaderTextSfKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"
    headerTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Header_Text"
    bodyTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Body_Text"
    submitButtonLabelSfKey="Global_Button_Next"
    [serialSearchResponse]="imeiStepResult.imeiLookupResult"
    (formSubmitted)="handleDeviceInfoFormSubmitted($event)"
    >
  </pgh-cellular-device-info-form>
</div>

  </ng-container>

</div>

</mat-sidenav-content>
</mat-sidenav-container>
